var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFYoung = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7868 41.5806C60.4381 45.0219 65.0178 50.9989 63.8013 55.2734C62.5848 59.5841 55.5721 62.2647 49.919 63.3514C44.2301 64.4744 39.865 64.0397 33.711 62.8081C27.557 61.5402 19.6498 59.4754 17.0379 54.3316C14.3902 49.1877 17.0737 40.9648 22.0827 37.4148C27.0561 33.8648 34.3908 34.9877 40.4017 36.0382C46.4484 37.0888 51.1355 38.103 55.7868 41.5806Z",
    fill: "#FA7B6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9001 40.5897C36.3793 40.3879 39.3252 38.6705 41.1421 36.203C43.0418 33.6229 43.6096 30.3544 43.6096 27.5162V26.6162H42.7096C37.3273 26.6162 34.1046 28.7441 32.2733 31.5413C30.4841 34.2743 30.1001 37.5268 30.1001 39.7097V50.9999H31.9001V40.5897ZM33.7793 32.5272C32.4841 34.5055 32.0294 36.8741 31.9252 38.7866C35.8775 38.5851 38.2575 37.0848 39.6926 35.1357C41.09 33.238 41.6715 30.8066 41.7873 28.4399C37.5419 28.6625 35.1539 30.4276 33.7793 32.5272Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0953 34.271C26.4918 34.0877 24.1119 32.8007 22.5938 30.9614C21.0919 29.1419 20.3453 26.6756 20.2123 23.9182C25.1969 24.1183 27.5637 25.9517 28.7566 28.0219C29.8938 29.9955 30.0686 32.3402 30.0953 34.271ZM31.9001 35.1288C31.9003 33.124 31.9007 29.8732 30.3162 27.1232C28.653 24.2366 25.3808 22.1001 19.2905 22.1001H18.3905V23.0001C18.3905 26.3739 19.1812 29.6547 21.2056 32.1073C23.1167 34.4226 26.0332 35.8864 30.1001 36.0732V42.871H31.9001L31.9001 35.1288Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 51.9001H15V50.1001H49V51.9001Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1364 16.2251L36.3153 20.0462L35.0425 18.7734L38.8636 14.9523L40.1364 16.2251Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3636 16.2251L27.1847 20.0462L28.4575 18.7734L24.6364 14.9523L23.3636 16.2251Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0841 18.3992L31.111 12.9954L32.9109 13.0044L32.8841 18.4082L31.0841 18.3992Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFYoung);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FYoung.c10b1ff986e9e1ab9da8f955fe0d08f7.svg";